import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import "../../styles/workouts-new/workouts.css";
import HelmetWrapper from "../../HelmetWrapper";
import { selectAuth } from "../../components/auth/auth.selector";
import { fetchWorkoutCategoriesData } from "../../redux/workout-reducers/workoutApis";
import AllWorkoutCategories from "../../components/workouts-new/categories/AllWorkoutCategories";
import SearchNButtons from "../../components/common-components/SearchNButtons";
import MealsStructure from "../../components/diet/meal/MealsStructure";

const WorkoutCategories = () => {
  const dispatch = useDispatch();
  const authData = useSelector(selectAuth);
  const userInfoData = authData.user;

  const { catLoading } = useSelector((state) => state.workoutApi);

  const iniModvalues = {
    isModOpen: false,
    cardName: "",
    rowData: "",
  };
  const [modValues, setModValues] = useState(iniModvalues);
  const [isPage, setIsPage] = useState(0);
  const iniAllFilter = {
    isActive: "",
    searchString: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    limit: 10,
    page: isPage + 1,
    status: allFilters.isActive?.value ? allFilters.isActive.value : "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);

  // function onResetFilters() {
  //   setAllFilters(iniAllFilter);
  //   setFilters(iniFilters);
  //   setSearchFilterApplied(false);
  //   setIsPage(0);
  // }

  function onCloseModalvalues() {
    setModValues(iniModvalues);
  }

  const onClickSearch = () => {
    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({ ...prevs, search: allFilters.searchString }));
      setIsPage(0);
    }
  };

  function getWorkoutCategory(filters) {
    dispatch(
      fetchWorkoutCategoriesData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      status: allFilters.isActive?.value ? allFilters.isActive.value : "",
    }));
  }, [allFilters.isActive, isPage]);

  useEffect(() => {
    getWorkoutCategory(filters);
  }, [filters]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
      setIsPage(0);
    }
  }, [allFilters.searchString]);

  return (
    <HelmetWrapper title="WTF: Workout Exercise">
      <Container className="bg-cloud-k px-50px" fluid>
        <Row>
          <Col>
            <MealsStructure text={"Workout Categories"} />
            {/* <CommonStructured
              pageHeading={"Workout Categories"}
              createBtnTxt={"+ Add New Workout Category"}
              onClickCreateBtn={() =>
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  cardName: "add",
                }))
              }
            /> */}
          </Col>
        </Row>

        <br />

        <Row>
          <Col>
            <SearchNButtons
              pageName={"workout-cats"}
              filters={allFilters}
              setFilters={setAllFilters}
              searchFilterApplied={searchFilterApplied}
              onClickSearch={onClickSearch}
              btnText={"+ Add New Workout Category"}
              onClickAdd={() =>
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  cardName: "add",
                }))
              }
            />
            {/* <CommonFilterStructure
              from={"only-search"}
              decryptedText={userInfoData}
              onClickReset={onResetFilters}
              filters={allFilters}
              setFilters={setAllFilters}
              onClickSearch={onClickSearch}
              searchFilterApplied={searchFilterApplied}
            /> */}
          </Col>
        </Row>

        <Row>
          <Col>
            <AllWorkoutCategories
              //   tbDatas={workoutCategoriesData?.data || []}
              isPage={isPage}
              setIsPage={setIsPage}
              callFunction={() => {
                getWorkoutCategory(filters);
              }}
              userInfoData={userInfoData}
              modValues={modValues}
              setModValues={setModValues}
              onCloseModalvalues={onCloseModalvalues}
            />
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default WorkoutCategories;
